var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppointments(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.75 4C9.16421 4 9.5 4.33579 9.5 4.75V6H14.5V4.75C14.5 4.33579 14.8358 4 15.25 4C15.6642 4 16 4.33579 16 4.75V6H17.25C18.2165 6 19 6.7835 19 7.75V18.25C19 19.2165 18.2165 20 17.25 20H6.75C5.7835 20 5 19.2165 5 18.25V7.75C5 6.7835 5.7835 6 6.75 6H8V4.75C8 4.33579 8.33579 4 8.75 4ZM17.25 7.5C17.3881 7.5 17.5 7.61193 17.5 7.75V10H6.5V7.75C6.5 7.61193 6.61193 7.5 6.75 7.5H17.25ZM6.5 11.5V18.25C6.5 18.3881 6.61193 18.5 6.75 18.5H17.25C17.3881 18.5 17.5 18.3881 17.5 18.25V11.5H6.5Z",
    fill: "#B1D1FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointments);
export default __webpack_public_path__ + "static/media/appointments.334015796960bab89222c99d491778fc.svg";
export { ForwardRef as ReactComponent };